import { render, staticRenderFns } from "./structTypeSan.vue?vue&type=template&id=0f837610&scoped=true&"
import script from "./structTypeSan.vue?vue&type=script&lang=js&"
export * from "./structTypeSan.vue?vue&type=script&lang=js&"
import style0 from "./structTypeSan.vue?vue&type=style&index=0&id=0f837610&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f837610",
  null
  
)

export default component.exports